// External Libraries
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// UI Components
import FormField from '../../components/ui/FormField';
import CheckboxField from '../../components/ui/CheckboxField';
import SelectField from '../../components/ui/SelectField';
import SubmitButton from '../../components/ui/SubmitButton';

// Redux Actions
import { addCurrencyFunc } from '../../../store/custom-actions/currencies-actions/AddCurrencySlicer';
import { getCurrenciesFunc } from '../../../store/custom-actions/currencies-actions/GetCurrenciesSlicer';

function NewCurrencyForm({ show, onHide }) {
  const { t } = useTranslation();
  const { register, reset, formState: { errors }, handleSubmit } = useForm();
  const { loading: submitLoading } = useSelector(state => state.addCurrencySlicer);
  const dispatch = useDispatch();

  const resetForm = () => {
    onHide();
    reset();
  };

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      is_active: data.is_active || false,
      sort_order: parseInt(data.sort_order) || 0,
    };
    
    const result = await dispatch(addCurrencyFunc({ data: payload }));

    if (addCurrencyFunc.fulfilled.match(result)) {
      dispatch(getCurrenciesFunc());
      resetForm();
    }
  };

  const positionOptions = [
    { value: 'before', label: t('Before') },
    { value: 'after', label: t('After') },
  ];

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header>
          <Modal.Title>{t('New Currency')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            id="submit-form-add"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              <div className="col-md-6">
                <FormField
                  label={t("Name")}
                  name="name"
                  register={register}
                  required={true}
                  errors={errors}
                  placeholder={t("Enter currency name")}
                />
              </div>
              <div className="col-md-6">
                <FormField
                  label={t("Code")}
                  name="code"
                  register={register}
                  required={true}
                  errors={errors}
                  placeholder={t("Enter currency code (e.g., USD)")}
                  maxLength={3}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <FormField
                  label={t("Symbol")}
                  name="symbol"
                  register={register}
                  required={true}
                  errors={errors}
                  placeholder={t("Enter currency symbol")}
                />
              </div>
              <div className="col-md-6">
                <SelectField
                  label={t("Position")}
                  name="position"
                  register={register}
                  required={true}
                  errors={errors}
                  options={positionOptions}
                  placeholder={t("Select position")}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <FormField
                  label={t("Sort Order")}
                  name="sort_order"
                  type="number"
                  register={register}
                  errors={errors}
                  placeholder={t("Enter sort order")}
                  min="0"
                />
              </div>
              <div className="col-md-6 d-flex align-items-end">
                <CheckboxField
                  name="is_active"
                  label={t("Active")}
                  register={register}
                  errors={errors}
                  defaultChecked={true}
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {t('Close')}
          </Button>
          <SubmitButton
            isLoading={submitLoading}
            form="submit-form-add"
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default NewCurrencyForm;
